// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__Gr-Vj","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__A6ag2"};